import createOportunity from "../services/salesforce";


export const COVERAGE_IDS = '[28,150,151,152,154]';
export const COVERAGE_WITH_MOTO_IDS = '[28,150,151,152,154,155]';

export const PLAN_ID = 417;
export const PLAN_SOA_ELECTRONICO = 416;
export const PLAN_AUTO_UNIFICADO = 555;
export const PLAN_VIVIR_SEGURO = 526;

export const amaDeCasa = '5';
export const estudiante = '4';

export const endPoints = {
  auth: {
    login: 'Account/LoginDefault',
  },
  catalog: 'catalogs/',
  catalog2: dat =>`catalogs/${dat}`,
  catalogByPlan: (planId, catalog) => `catalogs/${catalog}/${planId }`,
  catalogByPlanHab: (planId, cclaires) => `catalogs/catalogbyplan/${planId}/cactividadIH/${cclaires }`,
  catalogRiesgo: 'catalogs/riesgo',
  payment: 'payment/usd/authorize',
  paymentPay: 'payment/pay',
  paymentUpdate2: 'payment/update',
  paymentRevert: id => `payment/revert/${id}`,
  paymentApplyPayment: id => `payment/applyPayment/${id}`,
  questions: planId => `catalogs/plans/${planId}/questions/`,
  tarificar: planId => `Plans/${planId}/coverages/rates`,
  createOportunity: `message/sendOportunity`,
  updateAutoPolicy: 'policies/auto/UpdatePolicy',
  createOportunityIH: `message/sendOportunityIH`,
  createOportunityAuto: `message/SendOportunityAuto`,
  CreateOportunitySoaElectronico: `message/SendOportunitySoaElectronico`,
  failedRate: `message/email/ratefail`,
  paybyphonecall: `message/email/paybyphonecall`,
  notificationAuto: 'message/sendautonotification',
  notification: 'message/sendnotification',
  notificationAutoCR: 'message/SendNotificationAutoCR',
  sendNotificationAuto: 'message/SendNotificationAuto',
  notificationCoopenaeError: 'message/email/SendEmailCoopenaeError',
  notificationMailIH: (idPolicy, mail) => `message/email/SendMailIH/${idPolicy}/${mail}`,
  welcomeNotificationCR: policyId => `message/policies/${policyId}/SendWelcomeAutoNotificationCR`,
  welcomeNotificationAutoNI: (idPolicy, correo) => `message/email/SendMailAuto/${idPolicy}/${correo}`,
  welcomeNotificationAutoPol: (idPolicy) => `message/email/SendMailAuto/pol/${idPolicy}`,
  welcomeNotification: `message/email/SendEmailWelcome`,
  SendNotificationOpportunity: `message/SendNotificationOpportunity`,
  SendNotificationOpportunityDefault: `message/SendNotification`,
  documetos: id => `message/email/sendaseguradodocumentos?idPoliza=${id}`,
  contactameVSP: 'message/contactamevsp',
  createVida: 'policies/vida/create',
  createSOA: 'policies/SOA/create',
  createVivirSeguro: 'policies/vivirseguro/create',
  createCoopenaeAuto: 'policies/coopenae/auto/create',
  createIncendioHogar: 'policies/ih/create',
  getPolicy: id => `policies/get/${id}`,
  listPolicy: 'policies/GetList',
  banks: 'catalogs/bancos',
  paymentUpdate: 'payment/UpdatePayment',
  paymentUpdateSoa: 'usd/soa/authorize',
  paymentReceipt: (transactionId, download) => `payment/receipts/${transactionId}?download=${download}`,
  updateEnteAddress: (id) => `ente/${id}/UpdateAddress`,
  addCICAC: 'Ente/AddCICAC',
  saveKycNatural: 'Ente/SaveKycNatural',
  updateEnteEmail: 'ente/UpdateEnteEmail',
  updateEnte: 'Ente',
  ente: (id, typeDoc) => `Ente/${id}/identificatiionType/${typeDoc}`,
  department: (country) => `Catalogs/paises/${country}/departamentos`,
  country: (country, city) => `Catalogs/paises/${country}/departamentos/${city}/ciudades`,
  district: (country, city, canton) => `Catalogs/paises/${country}/departamentos/${city}/ciudades/${canton}/distritos`,
  neighborhood: (country, city, canton, district) => `Catalogs/paises/${country}/departamentos/${city}/ciudades/${canton}/distritos/${district}/barrios`,
  economicActivities: (type) => `Catalogs/entities/${type}/economicActivities`,
  configProductor: (productorId, planId) => `Catalogs/GetConfiguracionProductor/${productorId}/${planId}`,
  /*Auto*/
  brands: planId => `catalogs/plans/${planId}/brands`,
  deductibles: planId => `catalogs/plans/${planId}/deductibles`,
  coverages: planId => `catalogs/plans/${planId}/coverages`,
  typeBien: planId => `catalogs/plans/${planId}/bienes`,
  rastreosatelital: 'catalogs/rastreosatelital',
  models: (planId, brandId) => `catalogs/plans/${planId}/brands/${brandId}/models`,
  lastYear: (planId, brandId, moldelId) => `catalogs/plans/${planId}/brands/${brandId}/models/${moldelId}/lastyears/20`,
  lastYearNumber: (planId, brandId, moldelId, lastyear) => `catalogs/plans/${planId}/brands/${brandId}/models/${moldelId}/lastyears/${lastyear}`,
  datasheet: (planId, brandId, moldelId, year) => `catalogs/plans/${planId}/brands/${brandId}/models/${moldelId}/years/${year}/datasheet`,
  vhUses: 'catalogs/vehicles/uses',
  vhClass: 'catalogs/vehicles/class',
  vhTransmision: 'catalogs/transmision',
  vhClaseVehiculo: 'catalogs/claseVehiculo',
  vhCilindros: 'catalogs/cilindros',
  vhNoPuertas: 'catalogs/nopuertas',
  vhCombustible: 'catalogs/combustible',
  createCotizadorCr: 'policies/cotizadorcr/create',
  createCotizadorNi: 'policies/cotizadorni/create',
  createCotizadorHn: 'policies/cotizadorhn/create',
  updateCotizador:'policies/update',
  emissions: id => `policies/${id}/emissions`,
  descargarOferta: id => `Reports/policies/${id}/document/ofe`,
  descargarPoliza: id => `Reports/policies/${id}/document/pol`,
  configPlan: (branchId, planId) => `catalogs/branchs/${branchId}/plans/${planId}`,
  configPlans: (branchId) => `catalogs/branchs/${branchId}/plans`,
  configPlansUser: (branchId, username) => `catalogs/branchs/${branchId}/user/${username}/plans`,
  suminsuredbyplan: (planId) => `Catalogs/suminsuredbyplan/${planId}`,
  fees: (planId) => `Catalogs/plans/${planId}/fees`,
  validateVin: 'General/VinValidate',
  validateMail: 'General/MailValidate',
  discountByPlan: (idPlan) => `catalogs/GetDiscountByPlan/${idPlan}`,
  uploadFiles: `Policies/upload/files`,
  origenFondo: (type) => `Catalogs/GetOrigenFondo/${type}`,
  /*NOTIFICACIONES */
  notificationHub: `notificationHub`,
  sendAcceptNotification: 'message/SendAcceptNotification',
  associateConnetion: id => `message/AssociateConnetion/${id}`,
  /*ServiciosSL*/
  CrearTramite: 'ServiciosSL/NotificaTuSiniestro',
  SubirAdjuntoTramite: 'ServiciosSL/SubirAdjunto',
  CorreoNotificacion: 'ServiciosSL/EnvioCorreoSiniestro',
  CorreoNotificacionCliente: 'ServiciosSL/EnvioCorreoSiniestroCliente',
  SubirAjuntoEnvioCorreo: 'ServiciosSL/SubirAdjuntoEnvioCorreo',
  getPol: (cpol,anio, mes) => `ServiciosSL/SearchPolicyByCode/${cpol}/${anio}/${mes}`,
  getTechnicalDataPol: (pol) => `ServiciosSL/GetTechnicalByPolicy/${pol}`,
  getTechnicalDataPol2: `ServiciosSL/GetPolicyInfoByTechnicalData`,

  /*FLUJO*/
  CrearReclamo: 'Flujo/NotifyClaim',
  LoginServicioSL: 'Flujo/LoginServiceSL',
  getInformationInspectionClaim: id => `Flujo/Tramite/inspeccion/${id}`,
  getLstDamageType: `Flujo/Tramite/inspeccion/ListadoTipoDanio`,
  updateRegistrationInspection: 'Flujo/Tramite/inspeccion/actualizar',
  uploadFileInspection: `Flujo/Tramite/inspeccion/adjunto`,
  saveDamageVehicleDamage: (id, source) => `Flujo/Tramite/inspeccion/danio/${id}/${source}`,
  saveVehiclesInvolved: (id, source) => `Flujo/Tramite/inspeccion/vehiculoinvolucrado/${id}/${source}`,
  inspectionUploadFileToProcedure: (id) => `Flujo/Tramite/inspeccion/cargarArchivoAlTramite/${id}`,
  inspectionUploadFileToProcedureCheklist: (id) => `Flujo/Tramite/inspeccion/cargarArchivoAlTramiteCheckList/${id}`,
  getEnteInspection: (id) => `Flujo/Tramite/inspeccion/${id}/ente`,
  uploadReportInspectionToProcedure: (id) => `Flujo/Tramite/inspeccion/reporte/subiratramite/${id}`,
  sendMailInspection: (id) => `Flujo/Tramite/inspeccion/correo/${id}`,
  sendMailInspectionNew: (id, mail) => `Flujo/Tramite/inspeccion/correo/${id}/${mail}`,
  getApprovedPolicyById: (id) => `v1/Evicertia/GetApprovedPolicyById/${id}`,

  /*OpenBanking*/
  OpenBanking: 'OpenBanking/ValidateService',
  UpdateInsureBizagi: 'OpenBanking/UpdateInsureBizagi',

  //OPORTUNIDAD
  createOportunityNew: 'v1/oportunity/create',
  sendNotificatioOportunitySL: 'v1/oportunity/sendnotificationoportunitysl',
  updateOportunityLogPolicy:(oportunity, idpol) => `v1/Oportunity/UpdateOportunityLogPolicy/${oportunity}/${idpol}`,

  //NOTIFICACION
  sendNotficationNew : 'v1/notification/send',
  //BIENNES MUEBLES
  bienesMuebles: (type, data) => `BienesMuebles/ObtenerDatosVehiculo/${type}/${data}`

}

export const endPointFlujoReclamo = {
  CrearTramite: '/api/TramitesReclamo/NotificaTuSiniestro',
  Login: '/api/login/authenticate',
  SubirAdjuntoTramite: '/api/TramitesReclamo/SubirAdjunto',
  CorreoNotificacion: '/api/TramitesReclamo/EnvioCorreoSiniestro',
  CorreoNotificacionCliente: '/api/TramitesReclamo/EnvioCorreoSiniestroCliente'
}

export const umpeso = {
  lbrs: '0',
  kgs: '1'
}

export const telRegex = /^\d{4}-\d{4}$/;
export const cvvRegex = '\d\d\d';
export const tarjetaRegex = '^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$';
export const tarjetaVenceRegex = '^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$';
export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const cedulaMask = "999-999999-9999a";
export const cedulaPattern = /\d\d\d-\d\d\d\d\d\d-\d\d\d\d\w/;

export const tipoId = {
  cedula: '1',
  pasaporte: '2',
  ruc: '3',
}

export const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};



export const contentTitles = [
  'Datos personales',
  'Actividad económica',
  'Declaración de salud',
  'Beneficiarios',
  'Otros seguros',
  'Pago de póliza'
]

export const monedas = {
  dolares: 'U$',
  colones: '¢',
  cordobas: 'C$'
};

export const contentTitlesClaim = [
  "Información de contacto",
  "Registro del siniestro",
  "Levantamiento del siniestro",
];

export const TooltipFiguraTramite = {
  title: "Tipo de Cliente",
  text: "Se refiere a si usted es cliente de Seguros LAFISE (Asegurado) o sí resultó afectado por uno de nuestros clientes (Perjudicado)"
};

export const TooltipPolizaTramite = {
  title: "Póliza de nuestro cliente",
  text: "Se refiere al número de póliza de nuestro cliente que aparece en el Certificado de Tránsito emitido por la Policía."
};


export const MicrositioEnum = {
  Auto: 0, Soa: 1, Incendio: 2, VSP: 3, Vida: 4, VidaCorreduria: 5, IncendioAutoExpedibleContenido: 6
}

export const TypeValidation = {
  BiometricCheck: 1,
  BlackListCheck: 2,
  SelfieCheck: 3,
  DocumentCheck: 4
}

export const TypeMedia = {
  Selfie: 1,
  FrontalDocument: 2,
  BackDocument: 3
}

export const especialCoverage = {
  equipoEspecial: 264,
  equipoEspecialHN: 54,
  RoboHurto: 65,
  extraterritorialidad: 210,
  equipoEspecialCR: 264,
}

export const tipoNotificacionEnum = {
  DocumentoIdentidad: 0,
  FacturaEquiposEspeciales: 1,
  FacturaProforma: 2,
  InspeccionVehiculo: 3,
  RechazoPorOcupacionActividad: 4,
  SiniestroSalvamento: 5,
  PosVirtualExito: 6,
  PosVirtualError: 7,
  RechazoPorNacionalidad:8
}
